webpackJsonp([22],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  API_URL: "http://mb.izhaowo.com/api/",
  IMAGE_URL: "http://qn.s.izhaowo.com/",
  RPOJECT_URL: __webpack_require__.i({"NODE_ENV":"production","API_URL":"http://mb.izhaowo.com/api/","IMAGE_URL":"http://qn.s.izhaowo.com/","WXSIGN_API":"https://m.izhaowo.com:38080/weixin/","ISDOMAIN":".izhaowo.com","DETAIL_URL":"http://test2.rd.izhaowo.com:48980/","WX_DEBUG":false,"APPID":"wx23d38ccbaaa79b87","environment":"production","MB_CASE_URL":"http://m.izhaowo.com/mobile/case/list.html","URL_PREFIX":"http://cp.izhaowo.com/jhz","URL_PHOTO_FINISH":"http://cp.izhaowo.com/jhzView/html/page/photo/finish.html?code=","ASSETS_PUBLIC_PATH":"https://m.izhaowo.com/landing/","HOTEL_API":"https://hotel-api.izhaowo.com","API_URL2":"https://appapi.izhaowo.com/","NEW_API_URL":"https://api.izhaowo.com","LANDPAGE_URL":"https://cmsapi.izhaowo.com","SENDMSG_URL":"http://120.27.82.188:18037","SURVEY_URL":"https://api.izhaowo.com","VUE_APP_IMG_HOST":"https://img.izhaowo.com"}).RPOJECT_URL,
  DETAIL_URL: "http://test2.rd.izhaowo.com:48980/",
  WXSIGN_API: "https://m.izhaowo.com:38080/weixin/",
  APPID: "wx23d38ccbaaa79b87",
  MB_CASE_URL: "http://m.izhaowo.com/mobile/case/list.html",
  URL_PREFIX: "http://cp.izhaowo.com/jhz",
  URL_PHOTO_FINISH: "http://cp.izhaowo.com/jhzView/html/page/photo/finish.html?code=",
  ISDOMAIN: ".izhaowo.com",
  API_URL2: "https://appapi.izhaowo.com/",
  NEW_API_URL: "https://api.izhaowo.com",
  LANDPAGE_URL: "https://cmsapi.izhaowo.com",
  HOTEL_API: "https://hotel-api.izhaowo.com",
  SENDMSG_URL: "http://120.27.82.188:18037",
  SURVEY_URL: "https://api.izhaowo.com",
  VUE_APP_IMG_HOST: "https://img.izhaowo.com",
  ASSETS_PUBLIC_PATH: "https://m.izhaowo.com/landing/"
};

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nZepto = __webpack_require__(135);

var _nZepto2 = _interopRequireDefault(_nZepto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  install: function install(Vue, options) {
    Vue.prototype.checkPhone = function (num) {
      var mobile = /^[1][3-9]\d{9}$/;
      var mobile2 = /^[１][３,４,５,６,７,８][０,１,２,３,４,５,６,７,８,９]{9}$/;
      return mobile.test(num) || mobile2.test(num);
    };
    Vue.prototype.checkPrice = function (num) {
      var price = /^[1-9][0-9]{0,7}$/;
      return price.test(num);
    };
    Vue.prototype.checkPass = function (num) {
      var password = /^[A-Za-z0-9-_\~!:;|,·`@#\$\^&\*\.\(\)\[\]\{\}<>\\\/\'\"]{6,16}$/;
      return password.test(num);
    };
    Vue.prototype.checkCode = function (num) {
      var code = /^\d{4}$/;
      return code.test(num);
    };
    Vue.prototype.elData = function (json) {
      return eval('(' + json + ')');
    };
    Vue.prototype.getAjax = function (url, data, callback, errFun) {
      _nZepto2.default.ajax({
        type: "get",
        url: url,
        dataType: "json",
        crossDomain: true,
        contentType: "application/json;utf-8",
        data: data,
        success: function success(data2) {
          callback(data2);
        },
        error: errFun
      });
    };

    Vue.prototype.getAjaxPack = function (url, data, callback, errFun) {
      _nZepto2.default.ajax({
        type: "get",
        url: url,
        dataType: "jsonp",
        crossDomain: true,
        contentType: "application/json;utf-8",
        data: data,
        success: function success(data2) {
          callback(data2);
        },
        error: errFun
      });
    };

    Vue.prototype.setCookie = function (name, value, domain) {
      var d = new Date();
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      if (domain == "") {
        document.cookie = name + "=" + encodeURI(value) + "; path=/;" + expires;
      } else {
        document.cookie = name + "=" + encodeURI(value) + "; domain=.izhaowo.com;path=/;" + expires;
      }
    };

    Vue.prototype.clearCookie = function (name, value, domain) {
      var d = new Date();
      d.setTime(d.getTime() - 1);
      var expires = "expires=" + d.toUTCString();
      if (domain == "") {
        document.cookie = name + "=" + encodeURI(value) + "; path=/;" + expires;
      } else {
        document.cookie = name + "=" + encodeURI(value) + "; domain=.izhaowo.com;path=/;" + expires;
      }
    };

    Vue.prototype.getCookie = function (cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }if (c.indexOf(name) != -1) return decodeURI(c.substring(name.length, c.length));
      }
      return "";
    };
  }
};

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ResponseHelper = function ResponseHelper() {};

ResponseHelper.install = function (Vue, options) {
  var design = {
    width: 750
  };

  var maxView = {
    width: 750
  };

  var win = {};
  var view = {};

  window.onresize = function () {
    var doc = window.document;
    win.width = doc.documentElement && doc.documentElement.clientWidth || doc.body.clientWidth || window.innerWidth;
    win.height = doc.documentElement && doc.documentElement.clientHeight || doc.body.clientHeight || window.innerHeight;

    var e = navigator.userAgent;
    if (e.match(/iPhone|iPod/i) || e.indexOf("Android") > -1) {
      view = win;
    } else {
      var win_width = Math.min(win.width, maxView.width);

      view.width = win_width;

      var style = document.documentElement.style;
      style.width = win_width + 'px';
      style.marginLeft = style.marginRight = 'auto';
    }
    var remUnit = view.width * 100 / design.width;
    document.documentElement.style.fontSize = remUnit + 'px';
    Vue.prototype.rem2px = function (rem) {
      return rem * remUnit;
    };

    return this;
  }();

  Vue.prototype.view = view;
  Vue.prototype.win = win;
  Vue.prototype.design = design;
};

exports.default = ResponseHelper;

/***/ }),

/***/ 132:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 133:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(142);
exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "blockquote,body,button,caption,dd,div,dl,dt,fieldset,figure,form,h1,h2,h3,h4,h5,h6,hr,html,input,legend,li,menu,ol,p,pre,table,td,textarea,th,ul{margin:0;padding:0;-webkit-tap-highlight-color:transparent}address,article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}table{border-collapse:collapse;border-spacing:0}caption,th{text-align:left;font-weight:400}.float-bar,.footer a,.questions,.u-pointer{text-align:center}abbr,body,fieldset,html,iframe,img{border:0}img{vertical-align:middle}address,cite,dfn,em,i,var{font-style:normal}[hidefocus],summary{outline:0}li{list-style:none}h1,h2,h3,h4,h5,h6,small{font-size:100%}sub,sup{font-size:83%}code,kbd,pre,samp{font-family:inherit}q:after,q:before{content:none}textarea{overflow:auto;resize:none}label,summary{cursor:default}a,button{cursor:pointer}b,em,h1,h2,h3,h4,h5,h6,strong{font-weight:700}a,a:hover,del,ins,s,u{text-decoration:none}body,button,input,keygen,legend,select,textarea{font:12px/1.14 Avenir,Helvetica,Arial,sans-serif;color:#2c3e50;outline:0}.ch-table,.ch-table input{font-size:16px;width:100%}body{background:#fff;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}a,a:hover{color:#2c3e50}::-webkit-input-placeholder{color:transparent;text-overflow:ellipsis}body{background:#f1f0f1}body *{font-family:PingFangSC-Regular,微软雅黑,宋体,Verdane,Arial,Helvetica,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-size:12px;font-weight:400;line-height:.28rem;color:#555;letter-spacing:.29px;box-sizing:border-box}.m-colum{display:flex;flex-direction:column}.m-row{display:flex;flex-direction:row;justify-content:center}.m-rowspace{justify-content:space-around}.m-between{justify-content:space-between}input{height:40px;line-height:40px;font-size:12px;background:#fff;box-shadow:0 1px 4px 0 rgba(0,0,0,.02);border-radius:4px;border:none}input::-webkit-input-placeholder,textarea::-webkit-input-placeholder{color:#d5dbd9}input:-moz-placeholder,input::-moz-placeholder,textarea:-moz-placeholder,textarea::-moz-placeholder{color:#d5dbd9}input:-ms-input-placeholder,textarea:-ms-input-placeholder{color:#d5dbd9}::-webkit-scrollbar{width:1px;height:1px;background-color:transparent}::-webkit-scrollbar-track{background-color:transparent}::-webkit-scrollbar-thumb,::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px transparent;border-radius:10px}::-webkit-scrollbar-thumb{background-color:#d6dcda}.m-font28{font-size:14px;letter-spacing:.34px;line-height:.32rem}.m-font34{font-size:17px;letter-spacing:.41px;line-height:.38rem}.m-font24{font-size:12px;letter-spacing:.29px;line-height:.28rem}.m-font26{font-size:13px}.m-font52{font-size:26px;letter-spacing:.62px;line-height:.79rem}.m-c8{color:#c8c8c8}.m-tip{color:#9b9b9b}.m-ff85{color:#ff85ac}.m-hsbtn{background:#ff85ac;border-radius:100rem;color:#fff;font-size:17px;letter-spacing:.41px}.m-popup{position:fixed;height:100%;width:100%;left:0;top:0;background-color:#000;filter:alpha(opacity=50);background:rgba(0,0,0,.5);z-index:9999}.m-popup .m-table{width:100%;height:100%;table-layout:fixed;border-collapse:collapse;border-spacing:0}.m-popup .m-popup-con{width:6.5rem;position:relative;margin:0 auto;background-color:#fff;border-radius:8px;padding:0 .3rem}.m-popup-con *{text-align:center}.m-popup .m-pop-top{padding:.3rem 0;text-align:right;line-height:.12rem}.m-pop-top .m-close{display:inline-block;width:.4rem;height:.4rem;background:url(" + escape(__webpack_require__(141)) + ") no-repeat 0 0;background-size:.4rem}.m-pop-bot{padding-bottom:.5rem;line-height:.9rem}.m-errorcen{text-align:center;margin-top:20px}.zw-lr-layout{justify-content:space-between}.zw-lr-layout,.zw-lrc-layout,.zw-lrl-layout{display:flex;align-items:center}.zw-lrc-layout{justify-content:center}.zw-tb-layout,.zw-tbr-layout{display:flex;flex-direction:column;justify-content:space-between}.zw-tbr-layout{align-items:flex-end}.zw-tbc-layout{justify-content:space-between}.zw-tbc-layout,.zw-tbcc-layout{display:flex;flex-direction:column;align-items:center}.zw-tbcc-layout{justify-content:center}", ""]);

// exports


/***/ }),

/***/ 141:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkIxNzIwRkUyMzA0OTExRTZCQjUwOTkxRkIxMEExNUY3IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkIxNzIwRkUzMzA0OTExRTZCQjUwOTkxRkIxMEExNUY3Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QjE3MjBGRTAzMDQ5MTFFNkJCNTA5OTFGQjEwQTE1RjciIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QjE3MjBGRTEzMDQ5MTFFNkJCNTA5OTFGQjEwQTE1RjciLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7T/4/JAAACLklEQVR42uzb3UrDMBQH8C4O0WdRmeCVIN4IKurNQHAiir6YIOIUFCaKgl8MRPBOHCL4Jo6h1hPsoBS3Jk3Ox1gO/G9a6PIj3ZoculIcx9EwlYqGrAI4gAN4sKvc68Tz49NAw2bn5+zAmbtgDTIF+YA0ID9CXKVkbBXIO+QS8lVohlMXPINUU8euIOuQNjN2FHKUjKVbt5DVfui87/BSBhslF9SzPMaMPclgdS0mM174R2uix/FlRnQXW+1xftIF/NLnHAc6D6vrzQXchBwKQZtg9VguXJ/De5BjZrQJ9hxSg8Su4G/INiPaFLsB6fhaaXGhvWJtl5bUaO/YImtpKjQKtujmARuNhnXZLWGhUbGu20PfaHSsj/2wLzQJ1lcDwBVNhvXZ8SiKJsX6bvHYosmxph2PImhdmznoT2osBtgGHeXsemq+sb5vadvbmxyLCS6KRsVig23R6FgKsK4Rw5XWOMV4sD/A5NFD2i5SQrBkaCUIS4JWTNhGxNQjKzNha8kvuMmKTF+rLXGGbbCd1COrTjnTigmbfk7vUKIVI5YFrZix5GglAEuKVkKwZGglCEuCVsKw6GglEIuKVkKxaGglGIuCNgHvM2Jt0XVX8AJki7stY4HWE7PiAq4IwdqgKy7gliCsKbrlAn6AHGSOnTJis+j/xnbt2gDQry3pdxqnIa+Q+yjn1SBC9G6Cnon+Xi698dHx0Li7JBKrmcSoSuFfLQEcwAEcwILrV4ABADEz+K3WC8mlAAAAAElFTkSuQmCC"

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 6,
	"./af.js": 6,
	"./ar": 13,
	"./ar-dz": 7,
	"./ar-dz.js": 7,
	"./ar-kw": 8,
	"./ar-kw.js": 8,
	"./ar-ly": 9,
	"./ar-ly.js": 9,
	"./ar-ma": 10,
	"./ar-ma.js": 10,
	"./ar-sa": 11,
	"./ar-sa.js": 11,
	"./ar-tn": 12,
	"./ar-tn.js": 12,
	"./ar.js": 13,
	"./az": 14,
	"./az.js": 14,
	"./be": 15,
	"./be.js": 15,
	"./bg": 16,
	"./bg.js": 16,
	"./bm": 17,
	"./bm.js": 17,
	"./bn": 18,
	"./bn.js": 18,
	"./bo": 19,
	"./bo.js": 19,
	"./br": 20,
	"./br.js": 20,
	"./bs": 21,
	"./bs.js": 21,
	"./ca": 22,
	"./ca.js": 22,
	"./cs": 23,
	"./cs.js": 23,
	"./cv": 24,
	"./cv.js": 24,
	"./cy": 25,
	"./cy.js": 25,
	"./da": 26,
	"./da.js": 26,
	"./de": 29,
	"./de-at": 27,
	"./de-at.js": 27,
	"./de-ch": 28,
	"./de-ch.js": 28,
	"./de.js": 29,
	"./dv": 30,
	"./dv.js": 30,
	"./el": 31,
	"./el.js": 31,
	"./en-au": 32,
	"./en-au.js": 32,
	"./en-ca": 33,
	"./en-ca.js": 33,
	"./en-gb": 34,
	"./en-gb.js": 34,
	"./en-ie": 35,
	"./en-ie.js": 35,
	"./en-il": 36,
	"./en-il.js": 36,
	"./en-nz": 37,
	"./en-nz.js": 37,
	"./eo": 38,
	"./eo.js": 38,
	"./es": 41,
	"./es-do": 39,
	"./es-do.js": 39,
	"./es-us": 40,
	"./es-us.js": 40,
	"./es.js": 41,
	"./et": 42,
	"./et.js": 42,
	"./eu": 43,
	"./eu.js": 43,
	"./fa": 44,
	"./fa.js": 44,
	"./fi": 45,
	"./fi.js": 45,
	"./fo": 46,
	"./fo.js": 46,
	"./fr": 49,
	"./fr-ca": 47,
	"./fr-ca.js": 47,
	"./fr-ch": 48,
	"./fr-ch.js": 48,
	"./fr.js": 49,
	"./fy": 50,
	"./fy.js": 50,
	"./gd": 51,
	"./gd.js": 51,
	"./gl": 52,
	"./gl.js": 52,
	"./gom-latn": 53,
	"./gom-latn.js": 53,
	"./gu": 54,
	"./gu.js": 54,
	"./he": 55,
	"./he.js": 55,
	"./hi": 56,
	"./hi.js": 56,
	"./hr": 57,
	"./hr.js": 57,
	"./hu": 58,
	"./hu.js": 58,
	"./hy-am": 59,
	"./hy-am.js": 59,
	"./id": 60,
	"./id.js": 60,
	"./is": 61,
	"./is.js": 61,
	"./it": 62,
	"./it.js": 62,
	"./ja": 63,
	"./ja.js": 63,
	"./jv": 64,
	"./jv.js": 64,
	"./ka": 65,
	"./ka.js": 65,
	"./kk": 66,
	"./kk.js": 66,
	"./km": 67,
	"./km.js": 67,
	"./kn": 68,
	"./kn.js": 68,
	"./ko": 69,
	"./ko.js": 69,
	"./ku": 70,
	"./ku.js": 70,
	"./ky": 71,
	"./ky.js": 71,
	"./lb": 72,
	"./lb.js": 72,
	"./lo": 73,
	"./lo.js": 73,
	"./lt": 74,
	"./lt.js": 74,
	"./lv": 75,
	"./lv.js": 75,
	"./me": 76,
	"./me.js": 76,
	"./mi": 77,
	"./mi.js": 77,
	"./mk": 78,
	"./mk.js": 78,
	"./ml": 79,
	"./ml.js": 79,
	"./mn": 80,
	"./mn.js": 80,
	"./mr": 81,
	"./mr.js": 81,
	"./ms": 83,
	"./ms-my": 82,
	"./ms-my.js": 82,
	"./ms.js": 83,
	"./mt": 84,
	"./mt.js": 84,
	"./my": 85,
	"./my.js": 85,
	"./nb": 86,
	"./nb.js": 86,
	"./ne": 87,
	"./ne.js": 87,
	"./nl": 89,
	"./nl-be": 88,
	"./nl-be.js": 88,
	"./nl.js": 89,
	"./nn": 90,
	"./nn.js": 90,
	"./pa-in": 91,
	"./pa-in.js": 91,
	"./pl": 92,
	"./pl.js": 92,
	"./pt": 94,
	"./pt-br": 93,
	"./pt-br.js": 93,
	"./pt.js": 94,
	"./ro": 95,
	"./ro.js": 95,
	"./ru": 96,
	"./ru.js": 96,
	"./sd": 97,
	"./sd.js": 97,
	"./se": 98,
	"./se.js": 98,
	"./si": 99,
	"./si.js": 99,
	"./sk": 100,
	"./sk.js": 100,
	"./sl": 101,
	"./sl.js": 101,
	"./sq": 102,
	"./sq.js": 102,
	"./sr": 104,
	"./sr-cyrl": 103,
	"./sr-cyrl.js": 103,
	"./sr.js": 104,
	"./ss": 105,
	"./ss.js": 105,
	"./sv": 106,
	"./sv.js": 106,
	"./sw": 107,
	"./sw.js": 107,
	"./ta": 108,
	"./ta.js": 108,
	"./te": 109,
	"./te.js": 109,
	"./tet": 110,
	"./tet.js": 110,
	"./tg": 111,
	"./tg.js": 111,
	"./th": 112,
	"./th.js": 112,
	"./tl-ph": 113,
	"./tl-ph.js": 113,
	"./tlh": 114,
	"./tlh.js": 114,
	"./tr": 115,
	"./tr.js": 115,
	"./tzl": 116,
	"./tzl.js": 116,
	"./tzm": 118,
	"./tzm-latn": 117,
	"./tzm-latn.js": 117,
	"./tzm.js": 118,
	"./ug-cn": 119,
	"./ug-cn.js": 119,
	"./uk": 120,
	"./uk.js": 120,
	"./ur": 121,
	"./ur.js": 121,
	"./uz": 123,
	"./uz-latn": 122,
	"./uz-latn.js": 122,
	"./uz.js": 123,
	"./vi": 124,
	"./vi.js": 124,
	"./x-pseudo": 125,
	"./x-pseudo.js": 125,
	"./yo": 126,
	"./yo.js": 126,
	"./zh-cn": 127,
	"./zh-cn.js": 127,
	"./zh-hk": 128,
	"./zh-hk.js": 128,
	"./zh-tw": 129,
	"./zh-tw.js": 129
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 145;

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dayjs = __webpack_require__(144);

var _dayjs2 = _interopRequireDefault(_dayjs);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _api = __webpack_require__(0);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getUrlKey: function getUrlKey(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
  },
  formatDate: function formatDate(date) {
    return (0, _dayjs2.default)(date).format('YYYY年MM月DD日');
  },
  formatDateType: function formatDateType(date, type) {
    if (!date) return '';
    return (0, _moment2.default)(new Date(date)).format(type);
  },
  compareDate: function compareDate(date) {
    var now = new Date();
    return now.getTime() > date;
  },
  completUrl: function completUrl(url) {
    if (!url) return '';
    var isCompletion = url.includes('https://') || url.includes('http://');
    if (isCompletion) return url;
    return _api2.default.VUE_APP_IMG_HOST + (url.startsWith('/') ? url : '/' + url);
  },

  clip: function clip(url, width, height) {
    if (url && url.indexOf('blob:') !== -1) return url;
    if (!url) return '';
    var newUrl = url.includes('https://') || url.includes('http://') ? url : _api2.default.VUE_APP_IMG_HOST + (url.startsWith('/') ? url : '/' + url);

    if (height || width) {
      newUrl += newUrl.includes('?') ? '&' : '?';
    }

    if (height && width) {
      if (newUrl.includes('x-oss-process=image/resize,m_fill')) {
        newUrl = newUrl.split('?')[0] + '?x-oss-process=image/resize,m_fill,w_' + width + ',h_' + height;
      } else {
        newUrl += 'x-oss-process=image/resize,m_fill,w_' + width + ',h_' + height;
      }
    } else if (height) {
      newUrl += 'x-oss-process=image/resize,m_fill,h_' + height;
    } else if (width) {
      newUrl += 'x-oss-process=image/resize,m_fill,w_' + width;
    }

    return newUrl;
  },

  compress: function compress(url, quality) {
    if (!url) return '';
    var newUrl = url.includes('https://') || url.includes('http://') ? url : _api2.default.VUE_APP_IMG_HOST + (url.startsWith('/') ? url : '/' + url);

    return newUrl + (newUrl.includes('?') ? '&' : '?') + 'x-oss-process=image/quality,q_' + (quality || 100);
  }

};

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(143);

var _keys2 = _interopRequireDefault(_keys);

var _vue = __webpack_require__(136);

var _vue2 = _interopRequireDefault(_vue);

var _valid = __webpack_require__(130);

var _valid2 = _interopRequireDefault(_valid);

var _ResponseHelper = __webpack_require__(131);

var _ResponseHelper2 = _interopRequireDefault(_ResponseHelper);

var _utils = __webpack_require__(2);

var _utils2 = _interopRequireDefault(_utils);

var _elementUi = __webpack_require__(146);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(132);

__webpack_require__(133);

var _mintUi = __webpack_require__(139);

var _mintUi2 = _interopRequireDefault(_mintUi);

var _utils3 = __webpack_require__(2);

var _utils4 = _interopRequireDefault(_utils3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_elementUi2.default, { size: 'small', zIndex: 3000 });

_vue2.default.use(_mintUi2.default);

_vue2.default.use(_valid2.default);
_vue2.default.use(_ResponseHelper2.default);

_vue2.default.prototype.$utils = _utils2.default;
_vue2.default.prototype.bus = new _vue2.default();
_vue2.default.config.productionTip = false;
(0, _keys2.default)(_utils4.default).forEach(function (item) {
  return _vue2.default.filter(item, _utils4.default[item]);
});

exports.default = _vue2.default;

/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(991)
  __webpack_require__(992)
}
var Component = __webpack_require__(138)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(917),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-54fc4fd6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "menuAddress",
  created: function created() {
    document.title = "隐私政策";
  }
};

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ecardHWPolicy = __webpack_require__(379);

var _ecardHWPolicy2 = _interopRequireDefault(_ecardHWPolicy);

var _comm = __webpack_require__(3);

var _comm2 = _interopRequireDefault(_comm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

new _comm2.default({
  el: "#app",
  template: "<index/>",
  components: {
    index: _ecardHWPolicy2.default
  }
});

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports
exports.i(__webpack_require__(137), "");

// module
exports.push([module.i, ".info{padding:.2rem .4rem;font-family:PingFangSC-Regular;font-size:.26rem;color:#333;text-align:justify;line-height:.4rem;background:#fff}.info>div,.info>p{margin-bottom:.2rem}.info>p{color:#151515;font-weight:700}.info>p.align{text-align:center;margin:0 auto}", ""]);

// exports


/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "td[data-v-54fc4fd6]{border:1px solid #ececec;text-align:center;padding:.16rem .1rem}a[data-v-54fc4fd6]{word-break:break-all;cursor:pointer}b[data-v-54fc4fd6]{font-weight:700;color:#151515}", ""]);

// exports


/***/ }),

/***/ 917:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('p', {
    staticClass: "align"
  }, [_vm._v("《隐私政策》")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("更新日期：2026年04月22日")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("生效日期：2021年12月19日")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("引言")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      成都爱找我科技有限公司（以下简称“找我请柬”）非常重视您（也称“用户”）的个人信息，并让您对个人信息拥有控制权，找我请柬会使用强大的加密技术来保护您的隐私，同时制定严格的政策来管理所有数据。当您访问找我请柬运营的找我请柬平台时，或使用找我请柬提供的服务前，您需要同意本政策中关于找我请柬如何收集、使用、储存和分享您的相关信息的规定。如果您不同意本隐私政策中的任何内容，请立即停止使用或访问找我请柬的产品和服务。"), _c('b', [_vm._v("本政策中与您权益（可能）存在重大关系的条款，我们已使用加粗字体予以区别，请您重点查阅。")])]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      本隐私权政策旨在协助您了解找我请柬会收集哪些信息、为什么收集这些信息，以及您如何更新、管理、导出和删除自己的信息。若您对本政策有任何问题，请联系：service@izhaowo.com\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("术语")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      Cookie：Cookie\n      是包含字符串的小文件，会在您访问网站时发送到您的计算机上。当您再次访问网站时，Cookie\n      使该网站可以识别您的浏览器。Cookie\n      还能存储用户使用偏好及其他信息。您可以重置您的浏览器拒绝所有的\n      Cookie，或者在发送 Cookie 时提示。但如果没有\n      Cookie，某些网站功能或服务可能无法正常工作。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      应用数据缓存：应用数据缓存是指设备上的一种数据存储机制。使用它有很多好处，例如，可让网络应用在未连接互联网的情况下运行，以及可通过提高内容加载速度来改善相关应用的性能。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      个人信息：用户向找我请柬提供的、可用于识别用户的个人身份的信息，例如姓名、电子邮件地址、电话号码、银行卡号、身份证号码、住址、通讯记录等信息，或找我请柬可以正当地通过链接找到此类信息的其他数据。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      IP地址：每台连接到互联网的计算机都指定了唯一的编号，称为互联网协议 (IP)\n      地址。由于这些编号通常都是根据国家/地区的区域指定的，因此 IP\n      地址通常可用于识别计算机连接至互联网时所在的国家/地区。\n    ")]), _vm._v(" "), _c('p', [_vm._v("一. 找我请柬如何搜集和使用您的信息？")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("1. 找我请柬如何搜集您的信息？")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      找我请柬提供服务时，可能会收集、储存和使用下列信息：\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("1.1 您提供的信息")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      1.1.1\n      您在注册账户或使用找我请柬的服务时，向找我请柬提供的相关个人信息，例如您的"), _c('b', [_vm._v("姓名、电子邮件地址、电话号码、住址、身份证号码等信息。")]), _vm._v("如果您想充分使用找我请柬提供的各种分享功能，可能还需要"), _c('b', [_vm._v("创建公开显示的个人资料，其中可能会包含您的姓名和照片。")])]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      1.1.2\n      您通过找我请柬的服务向其他方提供的共享信息，以及您使用找我请柬的服务时上传、提交、存储、发送或接收的信息。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("1.2 您在使用服务过程中，找我请柬获取的信息")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_c('b', [_vm._v("找我请柬会收集您使用的服务以及使用方式的信息，")]), _vm._v("如您何时在找我请柬浏览产品，何时访问了找我请柬的产品服务，或何时查看了找我请柬的广告和内容。此类信息包括：\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_c('b', [_vm._v("1.2.1 日志信息")])]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      A.\n      设备或软件信息，例如您的移动设备、网页浏览器或用于接入找我请柬服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      B.\n      在使用找我请柬服务时搜索或浏览的信息，例如您使用的网页搜索词语、访问的社交媒体页面url地址，以及您在使用找我请柬服务时浏览或要求提供的其他信息和内容详情；\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_c('b', [_vm._v("1.2.2 IP地址")])]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      A.\n      有关您"), _c('b', [_vm._v("曾使用的移动应用（APP）和其他软件的信息，")]), _vm._v("以及您曾经使用该等移动应用和软件的信息；\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      B.\n      您通过找我请柬的服务进行通讯的信息，例如曾通讯的账号，以及通讯时间、数据和时长；\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      C. 您通过找我请柬的服务分享的内容所包含的信息（元数据），例如"), _c('b', [_vm._v("拍摄或上传的共享照片或录像的日期、时间或地点等。")])]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("1.2.3 设备中的视频、图片等")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      为了给您提供全方位的购物体验，经过您的授权，找我请柬的服务器会提取您设备中的"), _c('b', [_vm._v("视频、图片、版本号等，")]), _vm._v("并通过加密上传到服务器进行比对，用于匹配与该视频、图片、相对应的显示功能。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_c('b', [_vm._v("1.2.4 摄像头")])]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      除本协议另有约定外，您设备上的摄像功能是保证您能多角度观看产品效果必备工具，如您禁用摄像功能，可能无法使用找我请柬的部分产品或服务，或在使用过程中达不到最佳效果或使用受到限制。找我请柬不会利用摄像头采集您的个人照片，除非经您授权或您自行上传、提交、发布，找我请柬不会主动采集您设备中的图片、视频信息。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_c('b', [_vm._v("1.2.5 位置信息")])]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      为了让您更快的找到周边门店和相关服务，您可以授权开启设备定位功能并使用找我请柬基于位置提供的相关服务，当然，您也可以通过关闭定位功能随时停止找我请柬对您的地理位置信息的收集。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_c('b', [_vm._v("1.2.6 通讯录和好友圈")])]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      如您想分享找我请柬产品内容及图片给通讯录，找我请柬将根据您的授权上传并保存您的应用列表，并以加密方式上传并保存用户通讯录中联系人手机号码，通过与服务器中信息匹配为您提供特色服务。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("1.2.7 安全运行与风控验证")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      为了保障软件与服务的安全运行，防止您的个人信息被非法获取，更准确地预防欺诈和保护账号安全，我们会收集您的"), _c('b', [_vm._v("设备信息【包括:设备型号、设备名称、SIM卡序列号、设备唯一标识符(包括:"), _c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("IMEI、IMSI、IDFA")]), _vm._v(")】、地理位置、存储(相册、媒体和其他文件)、浏览器类型和设置、语言设置、操作系统和应用程序版本、网络设备硬件地址(MAC地址)、登录IP地址、接入网络的方式、网络质量数据、移动网络信息(包括运营商名称)、产品版本号以及软件使用记录信息，")]), _vm._v("如您不同意我们收集前述信息，可能无法完成风控验证。请您理解，为动态检测您的账户是否存在异常登录，每次您把找我请柬App切换至后台或重新启动程序时，我们可能会再次读取，我们将把读取频次控制在合理范围内。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("1.3第三方应用工具包")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      为了能够更高效地完成产品研发，为用户提供更为多元化的服务，找我请柬在找我请柬\n      App 中采用了第三方提供的软件开发工具包 。这种工具包通常称为 SDK（Software\n      Development\n      Kit），是指用于为特定的软件包、软件框架、硬件平台、操作系统等创建应用软件的开发工具的集合。找我请柬使用的\n      SDK 包括以下类型：\n    ")]), _vm._v(" "), _c('div', [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border": "1px solid #ececec",
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("第三方公司名称")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("产品/类型")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("共享信息名称")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("使用目的")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("使用场景")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("共享方式")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("共享方式 第三方个人信息处理规则")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("一键登录")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("中移互联网有限公司")]), _vm._v(" "), _c('td', [_vm._v("移动登录")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("设备信息、网络设备硬件地址、网络信息、OAID")])]), _vm._v(" "), _c('td', [_vm._v("一键登录")]), _vm._v(" "), _c('td', [_vm._v("一键登录")]), _vm._v(" "), _c('td', [_vm._v("SDK本机采集")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "http://dev.10086.cn/docInside?contentId=10000009826805",
      "target": "_blank"
    }
  }, [_vm._v("http://dev.10086.cn/docInside?contentId=10000009826805")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("中国电信股份有限公司")]), _vm._v(" "), _c('td', [_vm._v("电信")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("网络信息、读取手机状态")])]), _vm._v(" "), _c('td', [_vm._v("一键登录")]), _vm._v(" "), _c('td', [_vm._v("一键登录")]), _vm._v(" "), _c('td', [_vm._v("SDK本机采集")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "https://e.189.cn/legalStatement.jsp",
      "target": "_blank"
    }
  }, [_vm._v("https://e.189.cn/legalStatement.jsp")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("中国联通网络信息集团有限公司")]), _vm._v(" "), _c('td', [_vm._v("联通")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("网络信息、读取手机状态")])]), _vm._v(" "), _c('td', [_vm._v("一键登录")]), _vm._v(" "), _c('td', [_vm._v("一键登录")]), _vm._v(" "), _c('td', [_vm._v("SDK本机采集")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "http://m.client.10010.com/mobileService/tuwenhunpai/notice_1527478459203.html",
      "target": "_blank"
    }
  }, [_vm._v("http://m.client.10010.com/mobileService/tuwenhunpai/notice_1527478459203.html")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("地图及定位")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("高德软件有限公司")]), _vm._v(" "), _c('td', [_vm._v("高德地图")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("网络信息、地理位置、读取存储（信息、媒体和其他文件）权限、设备传感器信息")])]), _vm._v(" "), _c('td', [_vm._v("用于展现地图")]), _vm._v(" "), _c('td', [_vm._v("门店定位")]), _vm._v(" "), _c('td', [_vm._v("SDK本机采集")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "https://lbs.amap.com/pages/privacy/",
      "target": "_blank"
    }
  }, [_vm._v("https://lbs.amap.com/pages/privacy/")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("高德软件有限公司")]), _vm._v(" "), _c('td', [_vm._v("高德定位")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("地图位置（包含在后台状态下收集）、谁被信息、网络设备硬件地址、网络信息、读取存储（信息、媒体和其他文件）权限")])]), _vm._v(" "), _c('td', [_vm._v("帮助用户寻找附近门店时提供帮助")]), _vm._v(" "), _c('td', [_vm._v("门店定位")]), _vm._v(" "), _c('td', [_vm._v("SDK本机采集")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "https://lbs.amap.com/pages/privacy/",
      "target": "_blank"
    }
  }, [_vm._v("https://lbs.amap.com/pages/privacy/")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("其他")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("深圳市腾讯计算机系统有限公司")]), _vm._v(" "), _c('td', [_vm._v("微信开放平台")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("/")])]), _vm._v(" "), _c('td', [_vm._v("支持微信授权登录场景")]), _vm._v(" "), _c('td', [_vm._v("使用微信登录、微信分享")]), _vm._v(" "), _c('td', [_vm._v("SDK本机采集")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl",
      "target": "_blank"
    }
  }, [_vm._v("https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("深圳市腾讯计算机系统有限公司")]), _vm._v(" "), _c('td', [_vm._v("QQ开放平台")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("设备信息、网络设备地址、网络信息、读取存储（信息、媒体和其他文件）权限")])]), _vm._v(" "), _c('td', [_vm._v("帮助用户分享内容到QQ")]), _vm._v(" "), _c('td', [_vm._v("帮助用户分享内容到QQ")]), _vm._v(" "), _c('td', [_vm._v("SDK本机采集")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "https://wiki.connect.qq.com/qq%e4%ba%92%e8%81%94sdk%e9%9a%90%e7%a7%81%e4%bf%9d%e6%8a%a4%e5%a3%b0%e6%98%8e",
      "target": "_blank"
    }
  }, [_vm._v("https://wiki.connect.qq.com/qq%e4%ba%92%e8%81%94sdk%e9%9a%90%e7%a7%81%e4%bf%9d%e6%8a%a4%e5%a3%b0%e6%98%8e")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("北京微梦创科网络技术有限公司")]), _vm._v(" "), _c('td', [_vm._v("微博")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("设备信息、网络设备地址、网络信息、读取存储（信息、媒体和其他文件）权限")])]), _vm._v(" "), _c('td', [_vm._v("帮助用户分享内容至微博")]), _vm._v(" "), _c('td', [_vm._v("分享至微博")]), _vm._v(" "), _c('td', [_vm._v("SDK本机采集")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "https://open.weibo.com/wiki/Android_SDK%E8%AF%B4%E6%98%8E%E6%96%87%E6%A1%A3",
      "target": "_blank"
    }
  }, [_vm._v("https://open.weibo.com/wiki/Android_SDK%E8%AF%B4%E6%98%8E%E6%96%87%E6%A1%A3")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("阿里巴巴集团控股有限公司")]), _vm._v(" "), _c('td', [_vm._v("阿里云")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("网络信息、读取存储（信息、媒体和其他文件）权限")])]), _vm._v(" "), _c('td', [_vm._v("用于笔记发布、请柬制作、图片存储")]), _vm._v(" "), _c('td', [_vm._v("用户制作请柬、发布笔记的场景")]), _vm._v(" "), _c('td', [_vm._v("SDK本机采集")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "https://help.aliyun.com/document_detail/372512.html?spm=5176.22414175.sslink.1.6ab16422P6Ls9a",
      "target": "_blank"
    }
  }, [_vm._v("https://help.aliyun.com/document_detail/372512.html?spm=5176.22414175.sslink.1.6ab16422P6Ls9a")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("阿里巴巴集团控股有限公司")]), _vm._v(" "), _c('td', [_vm._v("阿里云OSS")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("网络信息、读取存储（信息、媒体和其他文件）权限")])]), _vm._v(" "), _c('td', [_vm._v("用于笔记发布、请柬制作、图片存储")]), _vm._v(" "), _c('td', [_vm._v("用户制作请柬、发布笔记的场景")]), _vm._v(" "), _c('td', [_vm._v("SDK本机采集")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "https://help.aliyun.com/document_detail/372512.html?spm=5176.22414175.sslink.1.6ab16422P6Ls9a",
      "target": "_blank"
    }
  }, [_vm._v("https://help.aliyun.com/document_detail/372512.html?spm=5176.22414175.sslink.1.6ab16422P6Ls9a")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("百度在线网络技术（北京）有限公司")]), _vm._v(" "), _c('td', [_vm._v("百度统计")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("【安卓】设备信息（设备型号、系统版本、oaid、IMEI等）、日志信息、应用程序列表信息、设备信息、读取/写入外部存储卡、获取运行列表、查看WLAN连接、读取手机状态和身份、使用蓝牙\n              【IOS】设备信息（设备型号、系统版本、系统总内存占用空间、操作系统等基础信息）、日志信息、应用程序列表信息、剪切板中的口令、链接等内容、读取/写入外部存储卡、获取运行列表、查看WLAN连接、使用蓝牙、广告标识符IDFA\n            ")])]), _vm._v(" "), _c('td', [_vm._v("\n            用于进行各功能的使用量、版本覆盖率等有助开发者、运营人员改善服务的数据监测，并且已做脱敏处理\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            （1）应用第一次安装启动时，收集系统基础信息和软件版本号\n            （2）新页面加载时，收集页面路径的加载次数等\n            （3）退出页面时，收集页面停留时长和页面路径退出次数。\n            （4）当有埋点时，收藏其他按钮的点击次数信息\n          ")]), _vm._v(" "), _c('td', [_vm._v("SDK本机采集")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "https://tongji.baidu.com/web/help/article?id=330&type=0",
      "target": "_blank"
    }
  }, [_vm._v("https://help.aliyun.com/document_detail/372512.html?spm=5176.22414175.sslink.1.6ab16422P6Ls9a")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("除此外，还包括其他功能相关的：")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      A. 用于"), _c('b', [_vm._v("进行数据监测，并且已做脱敏处理的的 SDK")]), _vm._v("（百度统计、友盟）\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      B 用于"), _c('b', [_vm._v("故障收集分析、帐号安全性核验")]), _vm._v("的\n      SDK（百度统计、友盟、腾讯Bugly）\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("C "), _c('b', [_vm._v("支付方式 ")])]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      名称：微信支付 运营方名称：深圳市腾讯计算机系统有限公司"), _c('br'), _vm._v("\n      使用目的：帮助用户完成微信支付"), _c('br'), _vm._v("\n      收集信息类型：设备信息(IMSI、IMEI、MAC地址)"), _c('br'), _vm._v("\n      收集方式：SDK本机采集、不涉及数据共享"), _c('br'), _vm._v("\n      官方说明或隐私政策：https://pay.weixin.qq.com/static/applyment_guide/applyment_index.shtml\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("D "), _c('b', [_vm._v("微信登录及微信分享 ")])]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      名称：微信 运营方名称：深圳市腾讯计算机系统有限公司"), _c('br'), _vm._v("\n      使用目的：微信登录、分享、帮助用户完成付款、提供安全认证服务"), _c('br'), _vm._v("\n      收集信息类型：设备信息(IMSI、IMEI、MAC地址、UUID)、设备存储"), _c('br'), _vm._v("\n      收集方式：SDK本机采集、不涉及数据共享 官方说明或隐私政策："), _c('br'), _vm._v("\n      https://developers.WeChat.qq.com/doc/oplatform/Mobile_App/Access_Guide/Android.html\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("2. 找我请柬可能将上述收集的信息用作以下用途：")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("2.1 向您提供服务；")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      2.2\n      "), _c('b', [_vm._v("在找我请柬提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保找我请柬向您提供的产品和服务的安全性；")])]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      2.3 帮助找我请柬设计新服务，改善找我请柬现有服务；\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("2.4 执行软件验证、升级服务；")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      2.5\n      应用户特殊要求而提供特定服务时，需要将信息提供给找我请柬的关联公司、第三方或其他用户；\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      2.6 其他有利于用户和找我请柬运营者利益且不违反任何强制性法律法规的情况。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("2.7 让您参与有关找我请柬产品和服务的调查")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("3. 找我请柬承诺")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      3.1\n      我们不会根据敏感类别（例如种族、宗教、性取向或健康状况）向您展示个性化广告；\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      3.2\n      "), _c('b', [_vm._v("我们不会与广告主分享可用于识别您个人身份的信息，例如您的姓名或电子邮件地址（除非经您授权同意）；")])]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      3.3\n      "), _c('b', [_vm._v("在任何时候、任何情况下都不会向任何第三方出售您的个人信息，我们只会在法律允许的范围内使用根据本协议获得的信息。我们会制定严格的政策保护您的个人信息，除非事先获得您的授权或本声明另有规定之外，不会将您的这些信息对外公开或向第三方提供。")])]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      4. 找我请柬不会将您的个人信息转移或披露给任何非关联的第三方，除非：\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      5.1 相关法律法规、法律程序、政府机关的强制性要求；\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("5.2 为完成合并、分立、收购或资产转让而转移；")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("3.3 事先获得您的授权；")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("5.4 您使用共享功能；")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("5.5 以学术研究或公共利益为目的；")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      5.6 找我请柬认为必要且不违反法律强制性规定的其他情形。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      6. "), _c('b', [_vm._v("除非经过您的同意，否则找我请柬不会向任何人提供您的敏感个人信息。")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("二. 如何更新、变更、导出、删除您的信息")])]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      1.\n      您在使用找我请柬的产品和服务时，会被要求提供您真实的个人信息，您应当对您所提供信息的真实性、合法性、有效性及完整性负责，并及时更新和维护您的个人信息，以保证信息的真实、合法和有效。您可以随时管理您的个人信息，例如您的个人账户注册信息。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      2.\n      "), _c('b', [_vm._v("您可以自行从找我请柬账号中删除您的内容或个人信息，或要求找我请柬删除或修改信息，")]), _vm._v("例如您想要删除个人帐户，可以发送邮件到service@izhaowo.com与我们联络并提出您的要求。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      3.\n      在有些情况下，找我请柬会出于法律目的或合法业务的需要将数据保留有限的一段时间。找我请柬会尽力确保找我请柬的服务能够保护信息免遭意外或恶意删除。因此，如果您删除了某些内容，找我请柬可能会过一段时间才会从找我请柬现用的和备用的系统中删除其副本。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      4.\n      "), _c('b', [_vm._v("您可以随时备份个人帐户名下的内容或将其用于非找我请柬服务，您可以发邮件到service@izhaowo.com与找我请柬联络并提出您的要求。")])]), _vm._v(" "), _c('p', [_vm._v("三. 找我请柬如何保护您的个人信息")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      1.\n      所有找我请柬产品都内置了强大的安全功能，并且找我请柬制定了严格的信息管理政策，配备专业的技术团队，采取了一系列合理的预防措施，以保护您的个人信息不会遭受未经授权的浏览、披露、滥用、变更、破坏以及损失，其中包括：\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      （1）使用加密技术来确保您的数据在传输过程中保持私密性；\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      （2）提供多种安全功能来协助您保护自己的帐号安全；\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      （3）审查找我请柬在收集、存储和处理信息方面的做法（包括实体安全措施），以防未经授权的人员访问找我请柬的系统；\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      （4）所有因提供服务而必须接触个人信息的找我请柬员工、承包商和代理商等，都需要遵守合同中规定的严格保密义务，否则可将被处分或被解约。\n    ")]), _vm._v(" "), _c('p', [_vm._v("四. 找我请柬如何处理未成年人提供的个人信息")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      1.\n      "), _c('b', [_vm._v("找我请柬非常重视未成年人信息的保护。找我请柬只会在法律允许的范围内，或依当地法律取得监护人的同意，或是为了保护未成年人而使用或披露有关未成年人的个人数据。“未成年人”的定义应考虑适用的法律以及各国家和地区的文化惯例。")])]), _vm._v(" "), _c('p', [_vm._v("五. 您分享的信息")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      1.\n      找我请柬会提供社交网络服务，您在使用这一类型服务时，您所上传或发布的信息（包括您公开的个人信息、您的通讯录、好友圈）、您对他人上传或发布的信息作出的回应，以及与这些信息有关的日志信息等，只要您不删除这些信息，它们会一直留存在公共领域，并被使用找我请柬服务的其他用户分享、浏览。即使您删除这些信息，有关信息仍可能由其他用户或不受找我请柬控制的非关联第三方独立地缓存、复制或储存，或由其他用户或第三方在公共领域保存。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      2.\n      请您谨慎考虑通过找我请柬的服务上传、发布和交流的信息内容。在一些情况下，您可通过找我请柬某些服务的隐私设定来控制有权浏览您共享信息的用户范围。您可以自行删除您上传、发布或分享的信息，如要求找我请柬为您删除您的相关信息，请发送邮件到service@izhaowo.com与找我请柬联络并提出您的要求。\n    ")]), _vm._v(" "), _c('p', [_vm._v("六. 数据传输")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      1.\n      找我请柬维护着遍布世界各地的服务器，因此，找我请柬处理您的信息时所用的服务器可能并不是位于您所在的国家或地区。数据保护法律因国家或地区而异，不同国家或地区的数据保护力度也是有强有弱。无论是在哪里处理您的信息，找我请柬都会一律采用本政策中所述的保护措施。另外，找我请柬还会遵守某些与数据传输有关的法律框架，例如“EU-US\n      Privacy Shield Frameworks”和“Swiss-US Privacy Shield Frameworks”。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      2.\n      收到正式的书面投诉后，找我请柬会与投诉方联系。找我请柬会与相应的监管机构（包括当地的数据保护机构）合作，以解决任何与传输您的数据有关且无法由找我请柬和您直接解决的投诉。\n    ")]), _vm._v(" "), _c('p', [_vm._v("七. 第三方服务提供商")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      1.\n      为方便您的访问并丰富您的体验，可能会有第三方提供的产品或服务。您可以选择是否访问这类内容或链接，或是否使用该第三方的产品或服务。但找我请柬对于第三方提供的产品或服务没有控制权。找我请柬无法控制第三方掌握的您的任何个人信息。您在使用第三方产品或服务过程中的信息保护问题，不适用于本政策的管理。本政策也不适用于您自行选择提供给第三方的任何信息。请您查看该第三方的隐私保护政策。\n    ")]), _vm._v(" "), _c('p', [_vm._v("八.本政策的更新")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      1.\n      找我请柬可能会不定期修改、更新本隐私政策，有关隐私政策的更新，找我请柬会在找我请柬APP中以通知公告等形式发布，您可以访问找我请柬查询最新版本的隐私政策。"), _c('b', [_vm._v("对于重大变更，找我请柬会向您发出郑重通知（包括对于某些服务，找我请柬会通过电子邮件发送通知，说明对隐私政策进行的更改）。")])]), _vm._v(" "), _c('p', [_vm._v("九. 适用范围")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      1.\n      找我请柬的隐私政策适用于由成都爱找我科技有限公司及其关联公司提供的所有服务，包括找我请柬及www.izhaowo.com上提供的服务，但是不包括附有独立隐私政策的服务（如第三方提供的产品和服务）。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      2.\n      找我请柬的隐私权政策不适用于第三方提供的产品和服务，例如在找我请柬及www.izhaowo.com上由第三方提供的产品和服务，以及在找我请柬的服务中链接到的其他网站，这些产品、服务或网站会有独立的隐私政策予以规范，请另行查阅相应的政策规定。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "textInfo"
  }, [_vm._v("\n      3.\n      对于为找我请柬的服务进行广告宣传，以及可能使用找我请柬的cookie或其他日志信息来投放和使用广告的其他公司和组织，找我请柬的隐私权政策并未涵盖其信息处理政策。\n    ")])])
}]}

/***/ }),

/***/ 991:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(655);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(134)("79f55a4b", content, true, {});

/***/ }),

/***/ 992:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(656);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(134)("b90717f6", content, true, {});

/***/ })

},[518]);


// WEBPACK FOOTER //
// static/js/landingPage_ecardHWPolicy.4a782c9207879e01c6cf.js